<template>
  <div>
    <!-- Label için inline mode -->
    <label v-if="title && isInline" :class="{'col-lg-3 col-md-3 col-sm-12': isInline}" :for="name">{{ title }}</label>

    <div :class="{'col-lg-9 col-md-9 col-sm-12': isInline}">
      <vue-tel-input v-model="displayValue"
                     :autoDefaultCountry="false"
                     :autoFormat="false"
                     :defaultCountry="selectedCountry || countryCode"
                     :disabled="disabled"
                     :inputOptions="phoneOptions"
                     :preferredCountries="['tr', 'az', 'de', 'ru', 'kz', 'ro', 'us']"
                     :validCharactersOnly="true"
                     mode="international"
                     @input="onInput"
                     @country-changed="onCountryChanged"
      />
    </div>

    <!-- Error ve hint -->
    <span v-if="hint" class="form-text text-muted">{{ hint }}</span>
    <p v-if="error" class="text-danger pt-1 px-3 block">{{ error }}</p>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import { AsYouType } from "libphonenumber-js";

export default {
  name: "PhoneInput",
  components: {
    VueTelInput,
  },
  props: {
    name: String,
    value: String,
    countryPhoneCode: String,
    title: String,
    disabled: Boolean,
    error: String,
    hint: String,
    placeholder: String,
    isInline: Boolean
  },
  data() {
    return {
      displayValue: this.value || '',
      selectedCountry: '',
      currentCountryIso: '',
      currentDialCode: this.countryPhoneCode || '90',
      phoneOptions: {
        placeholder: this.placeholder || '5XXXXXXXXX',
        maxlength: 20,
        styleClasses: ['uk-input'],
        type: 'tel',
        autocomplete: 'off'
      }
    }
  },
  mounted() {
    // Sayfa yüklendiğinde (edit sayfası) mevcut değeri formatla ve parent'a yansıt
    if (this.value) {
      this.$nextTick(() => {
        const formatted = this.formatAsYouType(this.value);
        this.displayValue = formatted;
        if (formatted !== this.value) {
          this.$emit('input', formatted);
        }
      });
    }
  },
  watch: {
    value(newVal) {
      const currentDigits = (this.displayValue || '').replace(/\D/g, '');
      const newDigits = (newVal || '').replace(/\D/g, '');
      if (currentDigits !== newDigits) {
        const formatted = this.formatAsYouType(newVal || '');
        this.displayValue = formatted;
      }
    }
  },
  methods: {
    formatAsYouType(number) {
      const country = this.currentCountryIso || this.countryCode;
      try {
        const formatter = new AsYouType(country.toUpperCase());
        const formatted = formatter.input(number);
        return formatted;
      } catch (e) {
        return number;
      }
    },
    onInput(formattedNumber) {
      if (!formattedNumber) {
        const restored = '+' + this.currentDialCode + ' ';
        this.displayValue = restored;
        this.$emit('input', restored);
        return;
      }

      // Ülke kodu koruması
      const prefix = '+' + this.currentDialCode;
      if (!formattedNumber.startsWith(prefix)) {
        const restored = prefix + ' ';
        this.displayValue = restored;
        this.$emit('input', restored);
        return;
      }

      // AsYouType ile anlık formatlama
      const formatted = this.formatAsYouType(formattedNumber);
      this.displayValue = formatted;
      this.$emit('input', formatted);
    },
    onCountryChanged(countryObject) {
      if (countryObject && countryObject.iso2) {
        this.selectedCountry = countryObject.iso2;
        this.currentCountryIso = countryObject.iso2;
      }
      if (countryObject && countryObject.dialCode) {
        this.currentDialCode = countryObject.dialCode;
      }
    }
  },
  computed: {
    countryCode() {
      const phoneCodeToCountry = {
        '90': 'TR',
        '994': 'AZ',
        '49': 'DE',
        '7': 'RU',
        '1': 'US',
        '40': 'RO',
      };
      const code = this.countryPhoneCode || '90';
      return phoneCodeToCountry[code] || 'TR';
    }
  }
}
</script>
